import { styled } from "~/generated/styled-system/jsx"
import { emphasisInHeading as emphasisInHeadingRecipe } from "~/generated/styled-system/recipes"

export const EmphasisInHeading = styled("em", emphasisInHeadingRecipe)
